/* eslint-disable no-param-reassign */
import { createStore, action } from "easy-peasy";

const Model = {
  // Middle screen
  experience: {
    isPlaying: false,
    setPlaying: action((state, payload) => {
      state.isPlaying = payload;
    }),
    hasOutro: false,
    setHasOutro: action((state, payload) => {
      state.hasOutro = payload;
    }),
    resetExperience: () => {},
    setResetExperience: action((state, payload) => {
      state.resetExperience = payload;
    }),
    isMuted: false,
    setMuted: action((state, payload) => {
      state.isMuted = payload;
    }),
    isFirstPlay: true,
    setFirstPlay: action((state, payload) => {
      state.isFirstPlay = payload;
    }),
  },
  // Player
  stage: {
    player: null,
    setPlayer: action((state, payload) => {
      state.player = payload;
    }),
    isPlaying: false,
    setPlaying: action((state, payload) => {
      state.isPlaying = payload;
    }),
    currentPlayingTime: 0,
    previousPlayingTime: 0,
    setCurrentPlayingTime: action((state, payload) => {
      state.currentPlayingTime = payload;
    }),
    setPreviousPlayingTime: action((state, payload) => {
      state.previousPlayingTime = payload;
    }),
    isSkipVisible: false,
    setSkipVisible: action((state, payload) => {
      state.isSkipVisible = payload;
    }),
  },
  // General experience
  demo: {
    isVisible: false,
    setVisible: action((state, payload) => {
      state.isVisible = payload;
    }),
    hasSizzle: true,
    setHasSizzle: action((state, payload) => {
      state.hasSizzle = payload;
    }),
    startTime: null,
    setStartTime: action((state, payload) => {
      state.startTime = payload;
    }),
  },
  // Navigation features list
  features: {
    features: [],
    setFeatures: action((state, payload) => {
      state.features = payload;
    }),
    activeFeature: -8,
    setActiveFeature: action((state, payload) => {
      state.activeFeature = payload;
    }),
  },
  // Menu
  navigation: {
    isVisible: false,
    setNavVisibility: action((state, payload) => {
      state.isVisible = payload;
    }),
  },
  // Background music
  bgm: {
    player: null,
    setBgmPlayer: action((state, payload) => {
      state.player = payload;
    }),
    isPlaying: false,
    setPlaying: action((state, payload) => {
      state.isPlaying = payload;
    }),
  },
  // Intro screen
  intro: {
    isVisible: true,
    setVisible: action((state, payload) => {
      state.isVisible = payload;
    }),
  },
  // Outro screen
  outro: {
    isVisible: false,
    setVisible: action((state, payload) => {
      state.isVisible = payload;
    }),
  },
  analytics: {
    totalPlayed: 0,
    setTotalPlayed: action((state, payload) => {
      state.totalPlayed = payload;
    }),
    currentIntervalStart: 0,
    setCurrentIntervalStart: action((state, payload) => {
      state.currentIntervalStart = payload;
    }),
    currentIntervalEnd: 0,
    setCurrentIntervalEnd: action((state, payload) => {
      state.currentIntervalEnd = payload;
    }),
    playCount: 0,
    setPlayCount: action((state, payload) => {
      state.playCount = payload;
    }),
  },
};

export default createStore(Model);
